import clsx from "clsx";
import { AppText } from "@/components/Text/AppText";

interface PasswordValidatorProps {
    password: string;
}

const check = () => (
    <svg
        className="size-4 shrink-0"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
);

const cross = () => (
    <svg
        className="size-4 shrink-0"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M18 6 6 18"></path>
        <path d="m6 6 12 12"></path>
    </svg>
);

interface RequirementProps {
    isValid: boolean;
    label: string;
}

const Requirement = ({ isValid, label }: RequirementProps) => (
    <div
        className={clsx(
            "flex items-center gap-1 rounded-full px-2",
            isValid
                ? "border-neutral-300 bg-neutral-50 text-neutral-500"
                : "border-neutral-400 bg-white text-neutral-700",
        )}
    >
        <span className="h-full">{isValid ? check() : cross()}</span>
        <AppText variant="footnote">{label}</AppText>
    </div>
);

export const PasswordValidator = ({ password }: PasswordValidatorProps) => {
    const validPassword = password.length >= 8;
    const validUppercase = /[A-Z]/.test(password);
    const validLowercase = /[a-z]/.test(password);
    const validNumber = /[0-9]/.test(password);

    return (
        <div className="mb-4">
            <AppText
                variant="footnote"
                className="mb-1 block !font-medium"
            >
                Your password must contain:
            </AppText>
            <div className="flex flex-wrap gap-1">
                <Requirement
                    isValid={validPassword}
                    label="8+ characters"
                />
                <Requirement
                    isValid={validUppercase}
                    label="Uppercase"
                />
                <Requirement
                    isValid={validLowercase}
                    label="Lowercase"
                />
                <Requirement
                    isValid={validNumber}
                    label="Number"
                />
            </div>
        </div>
    );
};
